<svg viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7_120)">
<path d="M7.5 13L13.9032 6.4947C14.5822 5.80603 15 4.85249 15 3.80359C15 1.70579 13.3182 0 11.25 0C9.18176 0 7.5 1.70579 7.5 3.80359C7.5 1.70579 5.81825 0 3.75 0C1.68175 0 0 1.70579 0 3.80359C0 4.85249 0.417827 5.80603 1.0968 6.4947L7.5 13Z" fill="#FF0000"/>
</g>
<defs>
<clipPath id="clip0_7_120">
<rect width="15" height="13" fill="white"/>
</clipPath>
</defs>
</svg>
